import React from "react";
import {
  ACTIONS,
  CallBackProps,
  EVENTS,
  Joyride,
  Step,
  LIFECYCLE,
} from "react-joyride";

export type Condition = {
  index: number;
  handler: () => void;
  action?: string;
  lifecycle?: string;
};

interface UserGuideProps {
  startTour: boolean;
  setStartTour: (startTour: boolean) => void;
  steps: Step[];
  conditions?: Condition[];
  targetIdToObserve?: string;
  setIsTargetObserved?: (observed: boolean) => void;
}

export default function UserGuide({
  startTour,
  setStartTour,
  conditions,
  steps,
  targetIdToObserve,
  setIsTargetObserved,
}: UserGuideProps) {
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, type, action, index, lifecycle } = data;
    const finishedStatuses: string[] = ["finished", "skipped"];

    if (finishedStatuses.includes(status) || type === EVENTS.TOUR_END) {
      setStartTour(false);
    }
    conditions?.forEach((condition) => {
      const conditionAction = condition.action || ACTIONS.NEXT;
      const conditionLifecycle = condition.lifecycle || LIFECYCLE.COMPLETE;
      if (
        condition.index === index &&
        action === conditionAction &&
        lifecycle === conditionLifecycle
      ) {
        condition.handler();
      }
    });
  };

  React.useEffect(() => {
    if (!targetIdToObserve) {
      setIsTargetObserved?.(true);
      return;
    }
    const observer = new MutationObserver(() => {
      const el = document.getElementById(targetIdToObserve);
      if (el) {
        setIsTargetObserved?.(true);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Joyride
      steps={steps}
      run={startTour}
      callback={handleJoyrideCallback}
      continuous
      styles={{
        options: {
          primaryColor: "#FFC62D",
          zIndex: 2000,
        },
      }}
      disableOverlayClose={true}
      disableScrolling={true}
    />
  );
}
